import { createActions } from "redux-actions";

export default createActions({
  TOP: {
    INDEX_OF_NOT_SIGNED_IN: {
      SET: (
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        userAgent
      ) => ({
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        userAgent,
      }),
    },
  },
});
